import React from 'react';

import { OPENING_PERMISSION } from 'pages/AccountingOpeningBalance/openingBalanceConfig';

const OpeningBalancePage = React.lazy(() => import('pages/AccountingOpeningBalance/OpeningBalancePage'));
const OpeningBalanceHistoryPage = React.lazy(() => import('pages/AccountingOpeningBalance/OpeningBalanceHistoryPage'));
const FinancialReportsPage = React.lazy(() => import('pages/AccountingOpeningBalance/FinancialReportsPage'));

const accountingFinancialRoute = [
  {
    path: '/accounting/opening-balances',
    exact: true,
    name: 'Nhập tồn đầu kỳ',
    function: OPENING_PERMISSION.VIEW,
    component: OpeningBalancePage,
  },
  {
    path: '/accounting/opening-balance-imports',
    exact: true,
    name: 'Lịch sử import dữ liệu đầu kỳ',
    function: [OPENING_PERMISSION.HISTORY, OPENING_PERMISSION.VIEW],
    any: true,
    component: OpeningBalanceHistoryPage,
  },
  {
    path: '/accounting/financial-reports',
    exact: true,
    name: 'Báo cáo tài chính',
    function: ['AC_FINANCIAL_REPORT_VIEW', 'RP_ACCOUNTING_REPORT_VIEW'],
    any: true,
    component: FinancialReportsPage,
  },
];

export default accountingFinancialRoute;
